// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__head-container__yx6v6 {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__title-container__zWi5s {
  display: flex;
  justify-content: flex-start;
  gap: 30px;
  align-items: center;
}
.index-module__extra-container__k7XSk {
  text-align: center;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 30px;
}
.index-module__highlighted-record-publishOn__O9hLJ {
  background-color: rgba(126, 196, 95, 0.5) !important;
  color: #000000;
}
.index-module__formDiv__ThYZb {
  padding-bottom: 3rem;
  padding-top: 0px;
  gap: 10px !important;
}
.index-module__formDivExtended__hR_g4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.index-module__info-text__R8XFT {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 15px;
  margin-left: 10vh;
}
.index-module__right-section-filter__hdUo1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Notification/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oDAAoD;EACpD,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.head-container {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.title-container {\n  display: flex;\n  justify-content: flex-start;\n  gap: 30px;\n  align-items: center;\n}\n.extra-container {\n  text-align: center;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 30px;\n}\n.highlighted-record-publishOn {\n  background-color: rgba(126, 196, 95, 0.5) !important;\n  color: #000000;\n}\n.formDiv {\n  padding-bottom: 3rem;\n  padding-top: 0px;\n  gap: 10px !important;\n}\n.formDivExtended {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.info-text {\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  font-size: 16px;\n  margin-bottom: 15px;\n  margin-left: 10vh;\n}\n.right-section-filter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head-container": `index-module__head-container__yx6v6`,
	"title-container": `index-module__title-container__zWi5s`,
	"extra-container": `index-module__extra-container__k7XSk`,
	"highlighted-record-publishOn": `index-module__highlighted-record-publishOn__O9hLJ`,
	"formDiv": `index-module__formDiv__ThYZb`,
	"formDivExtended": `index-module__formDivExtended__hR_g4`,
	"info-text": `index-module__info-text__R8XFT`,
	"right-section-filter": `index-module__right-section-filter__hdUo1`
};
export default ___CSS_LOADER_EXPORT___;
